import 'core-js/stable';
import 'regenerator-runtime/runtime';

import '../bootstrap';
import $ from 'jquery';
import 'jquery-colorbox';

import Vue from 'vue';

Vue.component('clothes', require('./Clothes').default);
/**
 * DOMContentLoaded
 */

document.addEventListener('DOMContentLoaded', () => {
  let inputValue = $('input[name="about_cate1"]:checked').val();
  $('input[name="about_cate1"]').click(function() {
    if ($(this).val() == inputValue) {
      $(this).prop('checked', false);
      inputValue = null;
    } else {
      inputValue = $(this).val();
    }
  });
});

const app = new Vue({
  el: '#app',
});

import applyAddress from '../_modules/applyAddress';

// 郵便番号から住所を検索する
document.cloth.address_number.addEventListener('keyup', e => {
  applyAddress(e.target.value, 'pref_id', 'address');
});
